module.exports = __webpack_public_path__ + "img/mainpage.93829dcb.png";